import { createSelector } from 'reselect'
import { sortColumnByKey } from '../utils/sort'
import { PAPER_EXAM, DIGITAL_EXAM } from '../constants/SettingsConstants'

export const getExamWindowsForCourse = (state, testCd) =>
  state.settingsExamWindows.data?.[testCd] || {}

export const getSortedExamWindowsForCourse = (state, testCd, availableWindows = []) => {
  const examWindows = getExamWindowsForCourse(state, testCd)
  let examWindowsArray = Object.values(examWindows)
  if (availableWindows.length) {
    examWindowsArray = examWindowsArray.filter(window => {
      const index = availableWindows.findIndex(item => item.code === window.adminWindow)
      return index >= 0
    })
  }
  const sortedWindows = sortColumnByKey(examWindowsArray, ['sequence'], ['asc'])
  return sortedWindows
}

export const getAllExamWindows = state => state.settingsExamWindows.data || {}

export const selectExamWindowRefData = state => state.settingsExamWindows.examWindowRefData || {}
export const selectExamWindowDataForApprovalRequests = state =>
  state.approvalRequestExamWindows ?? {}
const selectApprovalRequestExamWindows = state => state.approvalRequestExamWindows

export const selectExamDateRefData = state => state.settingsExamWindows.examDateRefData

/**
 * May optionally be filtered by examFormat, format prop accepts: 'all', 'PAPER', 'DIGITAL'
 *
 * Example input:
 * examWindowData = {
 *   ADMIN3: { adminWindow: 'ADMIN3', displayName: 'Admin 3', sequence: 3 },
 *   ADMIN1: { adminWindow: 'ADMIN1', displayName: 'Admin 1', sequence: 1 },
 *   ADMIN2: { adminWindow: 'ADMIN2', displayName: 'Admin 2', sequence: 2 },
 * }
 **/
export const selectSortedExamWindowRefData = createSelector(
  [selectExamWindowRefData, (state, format) => format],
  (examWindowRefData, format = 'all') => {
    const formatOptions = ['all', PAPER_EXAM, DIGITAL_EXAM]
    if (!formatOptions.includes(format)) {
      console.log('selectSortedExamWindowRefData: Invalid "format" prop:', format)
    }
    if (format === 'all') {
      return sortColumnByKey(Object.values(examWindowRefData), ['sequence'], ['asc'])
    }
    const examWindows = Object.values(examWindowRefData).filter(
      ({ examFormat }) => examFormat === format
    )
    return sortColumnByKey(examWindows, ['sequence'], ['asc'])
  }
)

export const isExamPaper = (state, testCd, adminWindow) => {
  const admin = getExamWindowsForCourse(state, testCd)
  return admin[adminWindow]?.examFormat === PAPER_EXAM
}

export const selectApprovalRequestExamWindowsStatusProps = createSelector(
  [selectApprovalRequestExamWindows],
  approvalRequestExamWindows => {
    const { fetching, fetched, error } = approvalRequestExamWindows
    return { fetching, fetched, error }
  }
)

export const selectApprovalRequestExamWindowRefData = createSelector(
  [selectExamWindowDataForApprovalRequests, (state, educationPeriodCd) => educationPeriodCd],
  (approvalRequestExamWindowData, educationPeriodCd) => {
    return approvalRequestExamWindowData.examWindowRefData?.[educationPeriodCd]
  }
)
